import "reflect-metadata";
import { container } from "tsyringe";
import AuthClient from "./modules/auth/services/AuthClient";
import UserModule from "./modules/auth/store/AccountModule";
import NotificationsClient from "./modules/dashboard/services/NotificationsClient";
import SecurityClient from "./modules/security/services/SecurityClient";
import { EServices } from "@/types";
import StoreService from "@/store";
import AppRouter from "@/router";
import TransactionsClient from "./modules/transactions/services/TransactionsClient";
import BanksClient from "./modules/banks/services/BanksClient";
import RatesClient from "./modules/sell/services/RatesClient";
import HttpClient from "./services/HttpClient";
import CryptoMicroservicesClient from "./modules/sell/services/CurrenciesClient";
import AccountClient from "./modules/dashboard/services/AccountClient";
import AnnouncementClient from "./modules/sell/services/AnnoucementClient";
import WalletsClient from "./modules/wallets/services/WalletsClient";
import ReferralsClient from "./modules/referrals/services/ReferralsClient";
import ComplaintsClient from "./modules/dashboard/services/ComplaintsClient";
import RanksClient from "./modules/sell/services/RanksClient";
import BiometricClient from "./modules/auth/services/BiometricClient";
import KycClient from "./modules/Kyc/services/KycClient";

container.register(EServices.auth, AuthClient);
container.register(EServices.store, StoreService);
container.register(EServices.http, HttpClient);
container.register(EServices.router, AppRouter);
container.register(EServices.security, SecurityClient);
container.register(EServices.notifications, NotificationsClient);
container.register(EServices.complaint, ComplaintsClient);
container.register(EServices.dashboard, UserModule);
container.register(EServices.transactions, TransactionsClient);
container.register(EServices.banks, BanksClient);
container.register(EServices.rates, RatesClient);
container.register(EServices.crypto, CryptoMicroservicesClient);
container.register(EServices.account, AccountClient);
container.register(EServices.announcement, AnnouncementClient);
container.register(EServices.wallets, WalletsClient);
container.register(EServices.referrals, ReferralsClient);
container.register(EServices.ranks, RanksClient);
container.register(EServices.biometric, BiometricClient);
container.register(EServices.kyc, KycClient);
